<template>
	<v-card>
		<v-card-title>
			<translate>
				Premium Comparison
			</translate>
		</v-card-title>
		<v-card-subtitle>
			<translate>
				The table takes around 30 seconds to load.
			</translate>
		</v-card-subtitle>
		<v-card-text>
			<v-row
				v-if="loaded"
			>
				<v-col>
					<device-name-search
						v-model="deviceId"
						:label="`${$gettext('Search For Device')}...`"
						variant="outlined"
					/>
				</v-col>
				<v-spacer />
			</v-row>
			<v-row>
				<v-col
					v-if="loaded"
				>
					<model-backend-table
						ref="comparisonTable"
						v-model:options="options"
						v-model:sort-desc="sortDesc"
						endpoint="/bo/pricing/premiumcomparison"
						:headers="tableHeaders"
						:filter="filter"
						:items-per-page-options="[ 10, 50, 100, ]"
					/>
				</v-col>
				<v-col
					v-else
				>
					<v-btn
						variant="flat"
						color="primary"
						@click="loaded = true"
					>
						Load Table
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>

export default {
	name: 'PricingParameterPremiumComparison',

	data () {
		return {
			deviceId: null,
			options: {
			},
			sortDesc: true,
			loaded: false
		};
	},

	computed: {
		tableHeaders () {
			return [
				{
					title: this.$gettext('Domain'), value: 'domain', sortable: false
				},
				{
					title: this.$gettext('Product Type'), value: 'productType', sortable: false
				},
				{
					title: this.$gettext('Device Name'), value: 'deviceName', sortable: false
				},
				{
					title: this.$gettext('Device ID'), value: 'deviceId', sortable: false
				},
				{
					title: this.$gettext('Current Premium'), value: 'currentPremium', sortable: false
				},
				{
					title: this.$gettext('Former Premium'), value: 'formerPremium', sortable: false
				},
				{
					title: this.$gettext('Delta'), value: 'delta', sortable: true
				},
			];
		},

		/**
		 * @returns {object}
		 */
		filter: function () {
			return{
				'device_id': this.deviceId
			};
		}
	}
};
</script>
